<template>
  <authorization permissionKey="attendance_surgery" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Cirurgias
        </v-col>
      </v-row>

      <SurgeryList :attendance="attendance" />
    </v-container>
  </authorization>
</template>

<script>
  import SurgeryList from "@/components/surgery/list/index.vue";

  export default {
    name: "Surgeries",
    props: {
      attendance: Object,
    },
    components: {
      SurgeryList,
    },
    methods: {
      createSurgery() {},
    },
  };
</script>

<style lang="scss" scoped></style>
